import { AnyAction, Dispatch } from 'redux';
import { ApiStatuses } from '../../../../global/models/api-model';
import { Institution } from '../../../../global/models/institution-model';
import { DioceseInstitutionItem, GhlPlans, InstitutionItem, InstitutionState, InstitutionStateActions, PlanSummary, OePlanOfferings } from './institution-model';

const InitialState: InstitutionState =
{
	institutionClientNumber: null,
	planSummary: null,
	planSummaryLoaded: false,
	currentInstitution: null,
	patchInstitutionStatus: ApiStatuses.None,
	employeeListLoaded: false,
	institutionList: [],
	dioceseList: [],
	dioceseListLoaded: false,
	institutionListLoaded: false,
	institutionSurveyFormStatus: ApiStatuses.None,
	removeRequestStatus: ApiStatuses.None,
	addRequestStatus: ApiStatuses.None,
	currentDioceseInstitution: null,
	manageInstitutionList: [],
	manageInstitutionListLoaded: false,
	ghlPlan: null,
	ghlPlanLoaded: false,
	oePlanOffering: null,
	oePlanOfferingLoaded: false,
};

export const institutionReducer = (state = InitialState, action: AnyAction): InstitutionState => {

	switch (action.type) {

		case InstitutionStateActions.SET_INSTITUTION_CLIENT_NUMBER:
			return {
				...state,
				institutionClientNumber: action.payload,
			};

		case InstitutionStateActions.SET_PLAN_SUMMARY:
			return {
				...state,
				planSummary: action.payload,
				planSummaryLoaded: true,
			};

		case InstitutionStateActions.SET_EMPLOYEELIST_LOADED:
			return {
				...state,
				employeeListLoaded: true,
			};

		case InstitutionStateActions.SET_EMPLOYEELIST_UNLOADED:
			return {
				...state,
				employeeListLoaded: false,
			};

		case InstitutionStateActions.UNLOAD_STATE:
			return {
				...state,
				institutionClientNumber: null,
				planSummary: null,
				planSummaryLoaded: false,
				currentInstitution: null,
				patchInstitutionStatus: ApiStatuses.None,
				employeeListLoaded: false,
				institutionGuid: null,
				dioceseInstitutionGuid: null,
				dioceseInstitutionClientNumber: null,
				dioceseInstitutionListLoaded: false,
				currentDioceseInstitution: null,
				ghlPlan: null,
				ghlPlanLoaded: false,
				oePlanOffering: null,
				oePlanOfferingLoaded: false,
			};
		case InstitutionStateActions.SET_INSTITUTION_INFO:
			return {
				...state,
				currentInstitution: action.payload,
			};
		case InstitutionStateActions.PATCH_INSTITUTION_STATUS:
			return {
				...state,
				patchInstitutionStatus: action.payload,
			};
		case InstitutionStateActions.SET_INSTITUTION_LIST:
			return {
				...state,
				institutionList: action.payload,
				institutionListLoaded: true,
			};
		case InstitutionStateActions.SET_MANAGE_INSTITUTION_LIST:
			return {
				...state,
				manageInstitutionList: action.payload,
				manageInstitutionListLoaded: true,
			};
		case InstitutionStateActions.INSTITUTION_SURVEY_STATUS:
			return {
				...state,
				institutionSurveyFormStatus: action.payload,
			};
		case InstitutionStateActions.SET_INSTITUTION_GUID:
			return {
				...state,
				institutionGuid: action.payload,
			};
		case InstitutionStateActions.SET_DIOCESE_LIST:
			return {
				...state,
				dioceseList: action.payload,
				dioceseListLoaded: true,
			};
		case InstitutionStateActions.SET_INSTITUTION_ADD_REQUEST_STATUS:
			return {
				...state,
				addRequestStatus: action.payload,
			};
		case InstitutionStateActions.SET_INSTITUTION_REMOVE_REQUEST_STATUS:
			return {
				...state,
				removeRequestStatus: action.payload,
			};
		case InstitutionStateActions.SET_DIOCESE_INSTITUTION_CLIENT_NUMBER:
			return {
				...state,
				dioceseInstitutionClientNumber: action.payload,
			};
		case InstitutionStateActions.SET_DIOCESE_INSTITUTION_GUID:
			return {
				...state,
				dioceseInstitutionGuid: action.payload,
			};
		case InstitutionStateActions.SET_DIOCESE_INSTITUTION_LIST:
			return {
				...state,
				dioceseInstitutionList: action.payload,
				dioceseInstitutionListLoaded: true,
			};
		case InstitutionStateActions.SET_DIOCESE_INSTITUTION_INFO:
			return {
				...state,
				currentDioceseInstitution: action.payload,
			};
		case InstitutionStateActions.SET_GHL_PLANS:
			return {
				...state,
				ghlPlan: action.payload,
				ghlPlanLoaded: true,
			};
		case InstitutionStateActions.SET_OE_PLAN_OFFERINGS:
			return {
				...state,
				oePlanOffering: action.payload,
				oePlanOfferingLoaded: true,
			};

		default: return state;
	}
};

export const setInstitutionClientNumber = (institutionClientNumber: string) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_CLIENT_NUMBER,
		payload: institutionClientNumber,
	};
};

export const setPlanSummary = (planSummary: PlanSummary) => {
	return {
		type: InstitutionStateActions.SET_PLAN_SUMMARY,
		payload: planSummary,
	};
};

export const unloadInstitutionState = () => {
	return {
		type: InstitutionStateActions.UNLOAD_STATE,
	};
};

export const setEmployeeListLoaded = () => {
	return {
		type: InstitutionStateActions.SET_EMPLOYEELIST_LOADED,
	};
};

export const setEmployeeListUnloaded = () => {
	return {
		type: InstitutionStateActions.SET_EMPLOYEELIST_UNLOADED,
	};
};

export const dispatchSetPlanSummary = (dispatch: Dispatch<any>) => (response) => {
	dispatch(setPlanSummary(response?.data?.plan_adoptions));
};

export const setCurrentInstitution = (institution: Institution) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_INFO,
		payload: institution,
	};
};

export const dispatchSetCurrentInstitution = (dispatch: Dispatch<any>) => (response) => {
	dispatch(setCurrentInstitution(response?.data));
};

export const dispatchResetInstitutionClientNumber = (dispatch: Dispatch<any>) => () => {
	dispatch(setInstitutionClientNumber(''));
};

export const setPatchInstitutionStatus = (status: ApiStatuses) => {
	return {
		type: InstitutionStateActions.PATCH_INSTITUTION_STATUS,
		payload: status,
	};
};

export const setInstituionList = (list: InstitutionItem[]) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_LIST,
		payload: list,
	};
};

export const setInstitutionSurveyStatus = (status: ApiStatuses) => {
	return {
		type: InstitutionStateActions.INSTITUTION_SURVEY_STATUS,
		payload: status,
	};
};

export const setInstitutionGuid = (guid: string) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_GUID,
		payload: guid,
	};
};

export const setDioceseList = (list: InstitutionItem[]) => {
	return {
		type: InstitutionStateActions.SET_DIOCESE_LIST,
		payload: list,
	};
};

export const setInstitutionAddRequestStatus = (status: ApiStatuses) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_ADD_REQUEST_STATUS,
		payload: status,
	};
};

export const setInstitutionRemoveRequestStatus = (status: ApiStatuses) => {
	return {
		type: InstitutionStateActions.SET_INSTITUTION_REMOVE_REQUEST_STATUS,
		payload: status,
	};
};

export const setDioceseInstitutionList = (list: DioceseInstitutionItem[]) => {
	return {
		type: InstitutionStateActions.SET_DIOCESE_INSTITUTION_LIST,
		payload: list,
	};
};

export const setDioceseInstitutionClientNumber = (institutionClientNumber: string) => {
	return {
		type: InstitutionStateActions.SET_DIOCESE_INSTITUTION_CLIENT_NUMBER,
		payload: institutionClientNumber,
	};
};

export const setDioceseInstitutionGuid = (guid: string) => {
	return {
		type: InstitutionStateActions.SET_DIOCESE_INSTITUTION_GUID,
		payload: guid,
	};
};

export const setCurrentDioceseInstitution = (institution: DioceseInstitutionItem) => {
	return {
		type: InstitutionStateActions.SET_DIOCESE_INSTITUTION_INFO,
		payload: institution,
	};
};

export const setManageInstituionList = (list: InstitutionItem[]) => {
	return {
		type: InstitutionStateActions.SET_MANAGE_INSTITUTION_LIST,
		payload: list,
	};
};

export const setGhlPlans = (plans: GhlPlans) => {
	return {
		type: InstitutionStateActions.SET_GHL_PLANS,
		payload: plans,
	};
};

export const setOePlanOfferings = (oeOffering: OePlanOfferings) => {
	return {
		type: InstitutionStateActions.SET_OE_PLAN_OFFERINGS,
		payload: oeOffering,
	};
};